/*
 *
 * Session actions
 *
 */

import {
  
  MY_ACCOUNT_LIST,
  MY_ACCOUNT_LIST_SUCCESS,
  MY_ACCOUNT_LIST_ERROR,
  DASHBOARD_ME_API,
  DASHBOARD_ME_API_SUCCESS,
  DASHBOARD_ME_API_ERROR
  
} from "./constants"

/**
 * @param {string} account_List
 */
export function myAccountApi(account_List) {
  return {
    type: MY_ACCOUNT_LIST,
    account_List,
  }
}

/**
 * @param {object} account_List
 */
export function myAccountApiSuccess(my_account_list) {
  return {
    type: MY_ACCOUNT_LIST_SUCCESS,
    my_account_list,
  }
}

/**
 * @param {string} error
 */
export function myAccountApiError(error) {
  return {
    type: MY_ACCOUNT_LIST_ERROR,
    error,
  }
}

export function dashboardMeApi (dashboar_Data) {
  return {
    type:DASHBOARD_ME_API,
    dashboar_Data
  }
}

export function dashboardApiSuccess (dashboar_Data) {
  return {
    type:DASHBOARD_ME_API_SUCCESS,
    dashboar_Data
  }
}

export function dashboardApiError (error) {
  return {
    type:DASHBOARD_ME_API_ERROR,
    error
  } 
}




const actions = {
  myAccountApi,
  myAccountApiSuccess,
  myAccountApiError,
  dashboardMeApi,
  dashboardApiError,
  dashboardApiSuccess

}

export default actions
